import { render, staticRenderFns } from "./KycList.vue?vue&type=template&id=5d509d2e"
import script from "./KycList.vue?vue&type=script&lang=js"
export * from "./KycList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports